import { useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import AccessRestrictionDialog from '../components/AccessRestrictionDialog';
import { accessMessages } from '../constants/accessMessages';

const RestrictedRoute = ({ children, allowedSubscriptions = [], restrictionKey }) => {
    
  const subscription = useSelector((state) => state.auth.user?.subscription);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    if (!allowedSubscriptions.includes(subscription)) {
      setShowModal(true);
    }
  }, [subscription, allowedSubscriptions]);

  if(showModal){
    return (
      <div className="flex justify-center items-center h-screen bg-white">
        <AccessRestrictionDialog
        content={accessMessages[restrictionKey]}
        onClose={() => {}}
        loadInitial={true}
        />
      </div>
    );
  }

  return children;
};

export default RestrictedRoute;
